import { generatePath } from '@cibo/core'
import Forward from '@mui/icons-material/ArrowForward'
import { LoadingButton } from '@mui/lab'
import { Card, CardActions, CardContent, Stack, TextField, Typography } from '@mui/material'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useCreateInventory } from '../../../../features/Inventories'
import { SCOPE_THREE_ROUTES } from '../../../../navigation/types/scopeThreeRoutes'

export const AddInventory = () => {
  const { t } = useTranslation('impact/AddInventory')
  const [inventoryName, setInventoryName] = useState('')
  const { mutateAsync, isLoading } = useCreateInventory()
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  return (
    <Stack alignItems="center" mt={8} data-testid="no-inventories">
      <Card
        variant="outlined"
        sx={{ borderRadius: 1.5, width: { xs: '100%', md: '40%' }, maxWidth: '560px', padding: 2 }}
      >
        <CardContent>
          <Stack spacing={3}>
            <Typography variant="h5">{t('header')}</Typography>
            <Typography variant="body1" color="text.secondary">
              {t('description')}
            </Typography>
            <TextField
              label={t('inventoryName')}
              placeholder={t('helper')}
              size="medium"
              InputLabelProps={{ shrink: true }}
              onChange={e => setInventoryName(e.target.value)}
              data-testid="inventoryNameTxtbox"
            />
          </Stack>
        </CardContent>
        <CardActions>
          <LoadingButton
            variant="contained"
            loading={isLoading}
            endIcon={<Forward />}
            disabled={!inventoryName}
            onClick={() =>
              mutateAsync(inventoryName)
                .then(response => {
                  navigate(
                    `${generatePath(SCOPE_THREE_ROUTES.SETUP, {
                      inventoryId: response.inventoryId,
                    })}?t=initial`
                  )
                })
                .catch(reason =>
                  enqueueSnackbar(t('creationFailure', { reason }), { variant: 'error' })
                )
            }
          >
            {t('continue')}
          </LoadingButton>
        </CardActions>
      </Card>
    </Stack>
  )
}
